import PartnerCard from '@jobseeker/lotus/components/PartnerCard';
import type {} from '@jobseeker/lotus/mui.types';
import {useState} from 'react';
import {PartnerCardDataType} from './types';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Box, Card, Typography} from '@mui/material';
import {useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';

const PartnerCompaniesSection = () => {
  const theme = useWrappedTheme();
  const styles = {
    partnerListContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: 5,
      overflowX: 'auto',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::webkitScrollbar': {
        display: 'none',
      },
      marginBottom: 9,
      flexWrap: 'wrap',
    },
    opportunityContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 470,
      margin: '0 auto',
      backgroundColor: 'primary.main',
      textAlign: 'center',
      color: '#fff',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 300,
      marginBottom: 3,
      flexWrap: 'wrap',
      padding: 1,
    },
  };
  const {
    timelines: {ads},
  } = useSelector((state: AppState) => state.competition);

  const partner1Slot = ads?.partnerCompanies1?.slotId ?? '';
  const partner2Slot = ads?.partnerCompanies2?.slotId ?? '';

  const [partners1, setPartners1] = useState<PartnerCardDataType[]>([]);
  const [partners2, setPartners2] = useState<PartnerCardDataType[]>([]);

  useLoadAds(partner1Slot, setPartners1, {}, false);
  useLoadAds(partner2Slot, setPartners2, {}, false);

  return (
    <Box id="partner-companies" sx={{marginBottom: 4}}>
      <Card
        sx={{
          width: '100%',
          margin: '0 auto',
          padding: {xs: 2},
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            margin: '0 auto',
            marginTop: 5,
            marginBottom: 5,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="sectionMainHeading"
            sx={{
              marginBottom: '5px',
              fontSize: {
                md: theme.typography.pxToRem(42),
                xs: theme.typography.pxToRem(32),
              },
            }}
          >
            Partner Companies
          </Typography>
        </Box>
        <Box
          sx={{
            ...styles.opportunityContainer,
            maxWidth: 440,
          }}
        >
          Internship opportunity -&nbsp;<b>For First year student</b>
        </Box>
        <Box sx={styles.partnerListContainer}>
          {partners1.map((partner1, index) => (
            <PartnerCard
              key={index}
              companyLogo={partner1.companyLogo}
              jobTitle={partner1.title}
              jobLocation={partner1.subText}
              link={partner1.link}
              description={partner1.description}
            />
          ))}
        </Box>

        <Box
          sx={{
            ...styles.opportunityContainer,
            maxWidth: 470,
          }}
        >
          Internship opportunity -&nbsp;<b>For Second year student</b>
        </Box>
        <Box sx={styles.partnerListContainer}>
          {partners2.map((partner2, index) => (
            <PartnerCard
              key={index}
              companyLogo={partner2.companyLogo}
              jobTitle={partner2.title}
              jobLocation={partner2.subText}
              link={partner2.link}
              description={partner2.description}
            />
          ))}
        </Box>
      </Card>
    </Box>
  );
};

export default PartnerCompaniesSection;
